module.exports = __webpack_public_path__ + "img/Group 107(3).f06fd9a4.svg";